module.exports = __webpack_public_path__ + "static/media/slap.4f762b7a.mp3";